// extracted by mini-css-extract-plugin
export default {"statics":"Statics_statics__nIFs2","active":"Statics_active__iIQjT"};